import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AdminGuard } from '../../shared/guard/admin.guard';

import { dashboardComponent } from './dashboard/dash-component';
import { accprofileComponent } from './accounts/myProfile/profile-component';
import { accadvertisersComponent } from './accounts/advertisers/adver-component';
import { accpublishersComponent } from './accounts/publishers/pub-component';
import { addpublisherComponent } from './accounts/publisherAdd/add-publisher-component';
import { editpublisherComponent } from './accounts/publisherEdit/edit-publisher-component';
import { finconversionsComponent } from './finance/conversions/conv-component';
import { finpaymentsComponent } from './finance/payments/payments-component';
import { fininvoiceComponent } from './finance/invoice/invoice-component';
import { importofferComponent } from './offers/import/import-offer-component';
import { campoverviewComponent } from './offers/alloffers/offers-component';
import { offerDetailsComponent } from './offers/offer-details/offer-details-component';
import { offerblacklistComponent } from './offers/black/black-component';
import { offerfraudComponent } from './offers/fraud/fraud-component';
import { settingsOfferComponent } from './offers/settings/settings';
import { logComponent } from './log/log-component';
import { dnsComponent } from './settings/dns/dns-component';

const routes: Routes = [
  {
    path: '',
    canActivate: [AdminGuard],
    children: [
      {
        path: 'dashboard',
        component: dashboardComponent,
        data: {
          // title: "Dashobard",
          breadcrumb: "Dashboard"
        }
      },
      {
        path: 'profile',
        component: accprofileComponent,
        data: {
          // title: "My profile",
          breadcrumb: "My profile"
        }
      },
      {
        path: 'publishers',
        component: accpublishersComponent,
        data: {
          // title: "Publishers",
          breadcrumb: "Publishers"
        }
      },
      {
        path: 'publishers/new',
        component: addpublisherComponent,
        data: {
          // title: "Publishers",
          breadcrumb: "Publisher New"
        }
      },
      {
        path: 'publishers/:id',
        component: editpublisherComponent,
        data: {
          // title: "Publishers",
          breadcrumb: "Publisher Edit"
        }
      },
      {
        path: 'advertisers',
        component: accadvertisersComponent,
        data: {
          // title: "Advertisers",
          breadcrumb: "Advertisers"
        }
      },
      {
        path: 'conversions',
        component: finconversionsComponent,
        data: {
          // title: "Finance conversions",
          breadcrumb: "Finance conversions"
        }
      },
      {
        path: 'payments',
        component: finpaymentsComponent,
        data: {
          // title: "Finance payments",
          breadcrumb: "Finance payments"
        }
      },
      {
        path: 'payments/:id',
        component: fininvoiceComponent,
        data: {
          // title: "Publishers",
          breadcrumb: "Finance invoice"
        }
      },
      {
        path: 'settings',
        component: settingsOfferComponent,
        data: {
          // title: "Campaings Overview",
          breadcrumb: "Settings"
        }
      },
      {
        path: 'offers',
        component: campoverviewComponent,
        data: {
          // title: "Campaings Overview",
          breadcrumb: "All Offers"
        }
      },
      {
        path: 'offers/:id',
        component: offerDetailsComponent,
        data: {
          // title: "Campaings details",
          breadcrumb: "All Offers / "
        }
      },
      {
        path: 'import',
        component: importofferComponent,
        data: {
          // title: "Campaings Overview",
          breadcrumb: "Import Offers"
        }
      },
      {
        path: 'fraud',
        component: offerfraudComponent,
        data: {
          // title: "Fraud",
          breadcrumb: "Fraud Import"
        }
      },
      {
        path: 'black',
        component: offerblacklistComponent ,
        data: {
         // title: "Campaings Black list",
          breadcrumb: "Offers Black lists"
        }
      },
      {
        path: 'sysset',
        component: dnsComponent,
        data: {
          // title: "Log",
          breadcrumb: "System Settings"
        }
      },
      {
        path: 'log',
        component: logComponent,
        data: {
          // title: "Log",
          breadcrumb: "System Log"
        }
      }

    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule { }
